module.exports = __webpack_public_path__ + "img/wifi.1f1fb474.svg";